import Axios from "../common/axios"
import { AppState } from '../reducers'

enum Type {
    WAITING = "FETCH_USER_WAITING"
    , COMPLETED = "FETCH_USER_COMPLETED"
    , ERROR = "FETCH_USER_ERROR"
}

interface Action {
    type: Type
    payload: any
}

export const fetch = (tenantId: number, filter: any = {}) => async (dispatch: (action: Action) => Action, getState: () => AppState) => {
    const state = getState().user

    if (state.loading || state.fetched) {
        return
    }

    const uri = `/api/${tenantId}/user`
    const cache = sessionStorage.getItem(uri)

    if (cache) {
        return dispatch({ type: Type.COMPLETED, payload: { data: JSON.parse(cache) } })
    }

    dispatch({ type: Type.WAITING, payload: { filter } })

    try {
        const { data, request } = await Axios.get(uri, filter)

        if (request.responseURL.endsWith("/login")) {
            throw new Error("redirected to /login")
        }

        sessionStorage.setItem(uri, JSON.stringify(data))
        dispatch({ type: Type.COMPLETED, payload: { data } })
    } catch (error) {
        dispatch({ type: Type.ERROR, payload: { error } })
    }
}

export interface UserState {
    loading: boolean
    , fetched: boolean
    , data: any[]
    , included: any[]
}

const reducer = (prevState: UserState, action: Action): UserState => {
    const state = { ...prevState }

    switch (action.type) {
        case Type.WAITING:
            state.loading = true
            break
        case Type.COMPLETED:
            state.loading = false
            state.fetched = true

            const { data, included } = action.payload.data

            state.data = [...data]

            if (included) {
                state.included = [...included]
            }
            break
    }

    return state
}

export default reducer
